import { useState } from 'react';
import type { CSSProperties, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

// Página a la que llega el usuario tras abrir el enlace de recuperación
// (/auth/confirm verifica el token y crea una sesión de recovery, luego
// redirige aquí). Aquí elige una contraseña nueva.
export default function ResetPassword() {
  const navigate = useNavigate();
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    if (pass.length < 6) { setError('La contraseña debe tener al menos 6 caracteres.'); return; }
    if (pass !== pass2) { setError('Las contraseñas no coinciden.'); return; }
    setBusy(true);
    try {
      const { error: err } = await supabase.auth.updateUser({ password: pass });
      if (err) throw err;
      setDone(true);
      setTimeout(() => navigate('/bandeja', { replace: true }), 1200);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo cambiar la contraseña');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={styles.screen}>
      <form onSubmit={handleSubmit} style={styles.card}>
        <div style={styles.brandRow}>
          <img src={`${process.env.PUBLIC_URL}/simplyteam-mark.svg`} alt="" width={36} height={36} />
          <h1 style={styles.title}>Simply<span style={{ color: '#2563eb' }}>Team</span></h1>
        </div>

        {done ? (
          <p style={styles.subtitle}>Contraseña actualizada. Entrando…</p>
        ) : (
          <>
            <p style={styles.subtitle}>Elige una contraseña nueva para tu cuenta.</p>
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              autoComplete="new-password"
              required
              style={styles.input}
            />
            <input
              type="password"
              placeholder="Repite la contraseña"
              value={pass2}
              onChange={(e) => setPass2(e.target.value)}
              autoComplete="new-password"
              required
              style={styles.input}
            />
            {error && <p style={styles.error}>{error}</p>}
            <button type="submit" disabled={busy} style={styles.button}>
              {busy ? '...' : 'Guardar contraseña'}
            </button>
          </>
        )}
      </form>
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  screen: {
    minHeight: '100vh',
    background: '#f8fafc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Söhne', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    padding: 24,
  },
  card: {
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    padding: '40px 36px',
    width: 380,
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
  },
  brandRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 },
  title: { fontSize: 24, fontWeight: 800, textAlign: 'center', margin: 0, color: '#0f172a', letterSpacing: '-0.3px' },
  subtitle: { textAlign: 'center', color: '#64748b', fontSize: 14, margin: '0 0 8px' },
  input: {
    background: '#fff', border: '1px solid #cbd5e1', borderRadius: 8,
    padding: '11px 14px', color: '#0f172a', fontSize: 15, outline: 'none',
  },
  error: { color: '#dc2626', fontSize: 13, textAlign: 'center', margin: 0 },
  button: {
    background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8,
    padding: '11px 0', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 4,
  },
};
